import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = async (route, _state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  await authService.initAuth();

  if (authService.isAuthenticated()) {
    return true;
  }

  const routeName = route.parent?.paramMap.get('routeName') ?? 'demorino';
  router.navigate([`/u/${routeName}/home`]);
  return false;
};
